import React, { useState } from "react";
import Navbar from "../components/Navbar/Index";
import { useOutletContext } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";

function Form() {
  const [sidebarToggle] = useOutletContext();
  const [friendEmail, setFriendEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const user = JSON.parse(localStorage.getItem("user"));

  const handleInputChange = (event) => {
    setFriendEmail(event.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true)
    try {
      const response = await axios.post(
        'https://splithub-dev.salmonocean-218390b4.centralindia.azurecontainerapps.io/friends/AddFriend',
        { Friend: friendEmail },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${user.idToken}`,
          },
        }
      );
      console.log('Friend added successfully:', response.data);
      alert("Friend added successfully")
      setFriendEmail('')
      setLoading(false)
      // You can perform further actions here, such as showing a success message or redirecting the user
    } catch (error) {
      console.error('Error adding friend:', error);
      alert("Error adding friend")
      setFriendEmail('')
      setLoading(false)
      // Handle error cases, e.g., show an error message to the user
    }
  };

  return (
    <>
      <main className="h-full">
        <Navbar toggle={sidebarToggle} />

        {/* Main Content */}
        <div className="mainCard">
          <div className="border w-full border-gray-200 bg-white py-4 px-6 rounded-md">
            <form onSubmit={handleSubmit}>
              {/* With Icon */}
              <div className="mt-6 relative">
                <label
                  htmlFor="email"
                  className="text-sm text-gray-600"
                >
                  Invite friend with email
                </label>

                <div className="inline-flex items-center justify-center absolute left-0 top-[0.85rem] h-full w-10 text-gray-400">
                  <FontAwesomeIcon icon={faEnvelope} />
                </div>
                <input
                  id="email"
                  type="email"
                  name="email"
                  value={friendEmail}
                  onChange={handleInputChange}
                  required
                  className="text-sm placeholder-gray-500 pl-10 px-4 rounded-lg border border-gray-200 w-full md:py-2 py-3 focus:outline-none focus:border-emerald-400 mt-1"
                  placeholder="friend@gmail.com"
                />
              </div>

              <div className="mt-6 flex flex-row gap-4">
                {loading ? (
                    <div
                      className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
                      role="status">
                      <span
                        className="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]"
                      >Loading...</span>
                    </div>
                  
                ) :
                  <button className="bg-emerald-600 text-gray-100 px-3 py-2 rounded-lg shadow-lg text-sm" type="submit">
                    Invite
                  </button>
                }
              </div>
            </form>
          </div>
        </div>
      </main>
    </>
  );
}

export default Form;
